import { LowerCasePipe } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EntityStatus, PatchEntityStateDto } from '@workspace/data-types';
import { StateStatusDisplayPipe } from '@workspace/ng-data-access';
import { DtoChangedDetection } from '../../abstract';
import { AbstractDialogAuraComponent, DialogData } from '../../abstract/dialog.abstract.component';
import { DialogLayoutAuraComponent } from '../../layouts/dialog/dialog.component';
import { AuraEntityStateFormComponent } from './form/entity-state-form.component';

export interface PatchEntityDialogData extends DialogData {
  readonly status: EntityStatus;
  readonly deletionConfirmation?: boolean;
  readonly label?: string;
  readonly isAdmin?: boolean;
}

@Component({
  selector: 'aura-entity-state-dialog',
  templateUrl: './entity-state.dialog.component.html',
  imports: [
    DialogLayoutAuraComponent,
    MatButtonModule,
    MatFormFieldModule,
    AuraEntityStateFormComponent,
    StateStatusDisplayPipe,
    LowerCasePipe,
    FormsModule,
    MatInputModule,
  ],
})
export class EntityStateDialogAuraComponent extends AbstractDialogAuraComponent<PatchEntityDialogData> {
  entityStatus = EntityStatus;
  isPatchValid = signal(false);
  patchEntityState = signal<PatchEntityStateDto | null>(null);

  confirmText = 'DELETE';
  confirmInput = signal('');

  isConfirmValid = computed(() => {
    if (this.data.status === EntityStatus.DELETED && this.data.deletionConfirmation) {
      return this.confirmInput() === this.confirmText;
    }
    return true;
  });

  isValid = computed(() => {
    return this.isPatchValid() && this.isConfirmValid();
  });

  onDtoChanged(event: DtoChangedDetection<PatchEntityStateDto>): void {
    if (event.dto) {
      this.patchEntityState.set(event.dto);
    }
  }

  onValidityChanged(valid: boolean): void {
    this.isPatchValid.set(valid);
  }

  override onConfirm(): void {
    this.dialogRef.close(this.patchEntityState());
  }
}
